import { styled } from 'linaria/react';
import React, { FC } from 'react';
import background from 'src/assets/background.jpg';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	min-height: var(--view-height);
	background: linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url(${background});
	//background-size: cover;
`;

type AppContainerProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const AppContainer: FC<AppContainerProps> = (props) => {
	return (
		<Container {...props}/>
	);
};
